import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../navbar/navbar.comp';
import CurrentChallenge from '../../components/currentChallenge/currentChallenge.comp';
import './currentChallenges.style.scss';
import { UserContext } from "../../contexts/user.context";
import {
    getCurrentAcceptedChallengesForUser,
    updateAcceptedChallenge
} from "../../utils/firebase/firebase.utils";
import Button from '../button/button.comp';
import { useChallenge } from '../../contexts/challenges.context';
import { initialChallenges } from '../../utils/initialObjects.comp'
import { formatDateToNumericString } from '../../utils/dating.utils';

const CurrentChallenges = () => {

    //[1] INPUTS
    const navigate = useNavigate();
    const { userID } = useContext(UserContext);
    const { setSelectedChallenge } = useChallenge();


    //[2] GET CHALLENGES
    const [challenges, setChallenges] = useState(initialChallenges[0]);
    const [loadedBoolean, setLoadedBoolean] = useState(false)
    const [today, setToday] = useState(new Date());
    useEffect(() => {
        const timer = setTimeout(async () => {
            const loadedChallenges = await getCurrentAcceptedChallengesForUser(userID);
            setChallenges(loadedChallenges);
            setToday(new Date());
            setLoadedBoolean(true)

        }, 200);

        return () => clearTimeout(timer);
    }, []);


    //[2] DATING
    const todayString = formatDateToNumericString(today);
    function formatDate(inputDate) {
        // Ensure the input is a valid Date object
        const date = new Date(inputDate);
        if (isNaN(date)) return 'Invalid Date';

        // Format the date to yyyymmdd
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}${month}${day}`;
    }


    //[3] NAV: To Challenge
    const navToChall = (challenge) => {
        setSelectedChallenge(challenge);
        navigate(`/acceptedChallenge`);
    };


    //[2] POST To Done Challenges    
    const [saveChallenge, setSaveChallenge] = useState(false);
    const [saving, setSaving] = useState(false)
    const [saved, setSaved] = useState(false)
    const [challengeToSaveId, setChallengeToSaveId] = useState()
    const [challengeToSaveObject, setChallengeToSaveObject] = useState()
    function markChallengeAsDone(challenges, uniqueId) {
        for (let i = 0; i < challenges.length; i++) {
            if (challenges[i].acceptedID === uniqueId) {
                setChallengeToSaveObject(challenges[i]); // Ensure this is set correctly
                challenges[i].doneBoolean = true;
                console.log(`Challenge with ID ${uniqueId} marked as done.`);
                return challenges[i]; // Return the updated challenge object
            }
        }
        console.log(`Challenge with ID ${uniqueId} not found.`);
    }


    //[3] POST To Done Challenges
    const handleMove = (uniqueAcceptedId) => {
        console.log('saving...')
        console.log(uniqueAcceptedId)
        setChallengeToSaveId(uniqueAcceptedId)
        setSaveChallenge(true)
    }
    const handleSaveInFirebase = async () => {
        console.log('firebase saving');
        const updatedChallenge = markChallengeAsDone(challenges, challengeToSaveId);

        if (!updatedChallenge) {
            console.error('No challenge found to save.');
            return;
        }

        try {
            setSaving(true);
            await updateAcceptedChallenge(challengeToSaveId, updatedChallenge);
            console.log('All challenges updated successfully.');
        } catch (error) {
            console.error('Error updating challenges:', error);
        }

        setSaving(false);
        setSaved(true);
    };


    //[3] POP UP: Move to Done Challenges 
    const handleCloseSaving = () => {
        setSaveChallenge(false)
        setSaving(false)
        setSaved(false)
    }
    const handleGoToDoneChallenges = () => {
        setSaveChallenge(false)
        setSaving(false)
        setSaved(false)
        navigate('/done')
    }


    return (
        <div>
            <Navbar option={5} />

            {/* Title */}
            <div className='section tight'>
                <h1 style={{ textAlign: 'left', color: 'var(--fontlightblack1)' }}>Current Challenges</h1>
                <p style={{ textAlign: 'left' }}>Challenges you are currently on.</p>
            </div>

            {/* <button onClick={() => console.log(challenges)}>Print</button> */}

            {/* Loading Circle */}
            {
                !loadedBoolean ? (
                    <div className="loading-circle"></div>
                ) : null
            }

            {/* Challenges List */}
            {
                loadedBoolean ? (
                    <div style={{ marginTop: '40px' }} className="section tight">
                        <div className='current-challenges-wrapper'>
                            <div className="current-challenges-scrollview">
                                {
                                    challenges.map((challenge, index) => {
                                        if (challenge.doneBoolean === false) {

                                            const trueCount = challenge.events.filter(event => event === true).length;

                                            const challengeIsDone = challenge.eventsTotal === trueCount;

                                            const lastDayString = formatDate(challenge.lastDay)

                                            const pastDayBoolean = todayString > lastDayString;

                                            const doneBoolean = trueCount === challenge.eventsTotal ? true : false;

                                            return (
                                                <div style={{ display: 'flex' }}>
                                                    <CurrentChallenge
                                                        key={index}
                                                        challenge={challenge}
                                                        acceptedID={challenge.acceptedID}
                                                        navToChall={() => navToChall(challenge)}
                                                        done={trueCount}
                                                        total={challenge.eventsTotal}
                                                        onMove={handleMove}
                                                        pastDayBoolean={pastDayBoolean}
                                                        doneBoolean={doneBoolean}
                                                        challengeIsDone={challengeIsDone}
                                                        todayString={todayString}
                                                        lastDayString={lastDayString}
                                                    />
                                                </div>
                                            );
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </div>
                ) : null
            }

            {/* Pop Up: Saving As Done */}
            {
                saveChallenge ? (
                    <div className="save-pop-up-container">
                        <div className="save-pop-up">
                            <div className="save-pop-up-header">
                                <div className="title">
                                    <div />
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleCloseSaving} />
                                </div>
                            </div>
                            {
                                saving ? (
                                    <div>
                                        <p style={{ textAlign: 'center' }}>Saving...</p>
                                        <div className="current-challenge-loading-circle"></div>
                                    </div>
                                ) : (
                                    saved ? (
                                        <div>
                                            <p style={{ textAlign: 'center' }} >Challenge moved to <strong>Done Challenges</strong></p>
                                            <Button text={'Go to Done Challenges'} option={'yellow'} onClick={handleGoToDoneChallenges} />
                                        </div>
                                    ) : (
                                        <div>
                                            {/* <p style={{ fontSize: 'large' }} >Congrats! You finished this challenge!</p> */}
                                            <p style={{ textAlign: 'center' }}>Save your progress and move this challenge to your <strong>Done Challenges</strong>?</p>
                                            <Button text={'Save'} option={'green'} onClick={handleSaveInFirebase} />
                                        </div>
                                    )
                                )
                            }
                        </div>
                    </div>
                ) : null
            }
        </div>
    );
};

export default CurrentChallenges;